import {
  model,
  Model,
  prop,
  modelAction,
  ModelCreationData,
} from 'mobx-keystone';

@model('bpEwells/SiteType')
export default class SiteType extends Model({
  id: prop<number>(),
  name: prop<string>(''),
  isActive: prop<boolean>(),
}) {
  @modelAction
  update(data: ModelCreationData<SiteType>) {
    Object.assign(this, data);
  }
}
